import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    // Make sure menu is hidden initially
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }

    // Close the menu when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle("hidden")

      // Toggle button icon between bars and X
      if (this.hasButtonTarget) {
        const icon = this.buttonTarget.querySelector('i')
        if (icon) {
          if (this.menuTarget.classList.contains("hidden")) {
            icon.classList.remove("fa-times")
            icon.classList.add("fa-bars")
          } else {
            icon.classList.remove("fa-bars")
            icon.classList.add("fa-times")
          }
        }
      }
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")

      // Reset button icon
      if (this.hasButtonTarget) {
        const icon = this.buttonTarget.querySelector('i')
        if (icon) {
          icon.classList.remove("fa-times")
          icon.classList.add("fa-bars")
        }
      }
    }
  }

  handleOutsideClick(event) {
    // Only process if we have targets and menu is visible
    if (this.hasMenuTarget &&
        !this.menuTarget.classList.contains("hidden") &&
        !this.element.contains(event.target)) {
      this.close()
    }
  }
}
